<template>
    <div class="display-container">
        <div class="display-content">
            <h2>房屋整体</h2>
            <div class="display-section">庄园设计师们，包含庄园整体，家具改造，装饰空间。</div>
            <div class="display-list">
                <site-card v-for="item in houseDesigners" :key="item.id" :screenshot="item.screenshot"
                    :avatar="item.avatar" :name="item.name" :description="item.description" 
                    @click="goToDesignerDetail(item.id)" />
            </div>
        </div>
        <div class="display-content">
            <h2>服装设计</h2>
            <div class="display-section">服装设计师们，包含个人男装、女装、情侣装。</div>
            <div class="display-list">
                <site-card v-for="item in fashionDesigners" :key="item.id" :screenshot="item.screenshot"
                    :avatar="item.avatar" :name="item.name" :description="item.description"
                    @click="goToDesignerDetail(item.id)" />
            </div>
        </div>
    </div>
</template>

<script>
import SiteCard from '@/components/SiteCard.vue'
import { fetchDesigners } from '@/services/api'

export default {
    name: 'DisplayPage',
    components: {
        SiteCard
    },
    data() {
        return {
            houseDesigners: [],
            fashionDesigners: []
        }
    },
    async created() {
        try {
            this.houseDesigners = await fetchDesigners();
        } catch (error) {
            console.error('获取设计师数据失败:', error);
        }
    },
    methods: {
        goToDesignerDetail(id) {
            this.$router.push(`/designer/${id}`)
        }
    }
}
</script>

<style scoped>
.display-container {
    max-width: 1200px;
    width: 90%;
    margin: 0 auto;
    padding: 80px 0;
    min-height: calc(100vh - 50px);
}

.display-content {
    border-radius: 12px;
    padding: 30px;
    margin-bottom: 20px;
}

.display-section {
    margin: 0;
    color: var(--adil-secondtext);
}

.display-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top: 20px;
}

@media (max-width: 768px) {
    .display-container {
        padding: 60px 0;
    }

    .display-content {
        padding: 20px;
    }

    .display-list {
        justify-content: center;
    }
}

:deep(.el-tooltip__popper) {
    max-width: 200px;
    line-height: 1.5;
    padding: 8px 12px;
    font-size: 12px;
    word-break: break-all;
    white-space: normal;
}
</style>